import { RouteConfig } from 'vue-router';
import { useLoanStore } from '@/stores/modules/loan';

export default [
  /**
   * 借款
   */
  {
    path: '/loan',
    meta: {
      title: '借款',
      customNavBar: true,
      excludeTracking: true,
    },
    beforeEnter: async (to, from, next) => {
      if (to.query.goToWaitingFund === '1') {
        const loanStore = useLoanStore();
        const productParams = loanStore.record.productParams;

        if (!productParams) {
          next();
          return;
        }

        next(false);
        if (productParams?.needFaceRecognition === '1') {
          next();
          return;
        }
        if (productParams?.needPersonalInfo === '1') {
          next({
            path: '/information/personal',
            replace: true,
          });
          return;
        }
        if (productParams?.needContactInfo === '1') {
          next({
            path: '/information/complete',
            replace: true,
          });
          return;
        }
        next();
      }
      next();
    },
    component: () => import('@/views/loan/normal/index.vue'),
  },
  /**
   * 资方授信等待页
   */
  {
    path: '/loan/fund/waiting',
    meta: {
      title: '匹配资金',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/loan/waiting-fund.vue'),
  },
  /**
   * 额度审批（联洗自流程）
   */
  {
    path: '/loan/approval/sign',
    meta: {
      title: '额度审批',
      customNavBar: true,
      background: '#F5F6FA',
    },
    component: () => import('@/views/loan/sign-approval.vue'),
  },
  /**
   * 额度审批（联洗自流程）
   */
  {
    path: '/loan/approval/waiting',
    meta: {
      title: '额度审批',
      customNavBar: true,
      background: '#F5F6FA',
    },
    component: () => import('@/views/loan/waiting-approval.vue'),
  },
  /**
   * 借款协议
   */
  {
    path: '/loan/agreement',
    meta: {
      title: '借款协议',
      background: '#fff',
    },
    component: () => import('@/views/loan/agreement.vue'),
  },
  /**
   * 放款结果
   */
  {
    path: '/loan/result',
    meta: {
      title: '放款结果',
      excludeTracking: true,
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/loan/result.vue'),
  },
  /**
   * 中转页
   */
  {
    path: '/loan/transit',
    meta: {
      title: '匹配资金源',
      background: '#F2F5FF',
    },
    component: () => import('@/views/loan/transit.vue'),
  },
  /**
   * 资方强制阅读协议页
   */
  {
    path: '/loan/mandatory/agreement',
    meta: {
      title: '相关协议',
      customNavBar: true,
      background: '#F2F5FF',
    },
    component: () => import('@/views/loan/mandatory-agreement.vue'),
  },
  /**
   * 资方强制阅读协议页-完全阅读模式
   */
  {
    path: '/loan/read-fully/agreement',
    meta: {
      title: '相关协议',
      customNavBar: true,
      background: '#F2F5FF',
    },
    component: () => import('@/views/loan/read-fully-agreement.vue'),
  },
  /**
   * 放款排队
   */
  {
    path: '/loan/queue',
    meta: {
      title: '排队中',
      background: '#fff',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/loan/queue.vue'),
  },
  /**
   * 预约借款
   */
  {
    path: '/loan/reservation',
    meta: {
      title: '预约提额借款',
      background: '#F5F6FA',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/loan/reservation/index.vue'),
  },
  /**
   * 预约借款
   */
  {
    path: '/loan/reservation/result',
    meta: {
      title: '预约结果',
      background: '#FFF',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/loan/reservation/result.vue'),
  },

  /**
   * 预约再借一笔
   */
  {
    path: '/loan/again-reservation',
    meta: {
      title: '再借一笔',
      background: '#F5F6FA',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/loan/again-reservation/index.vue'),
  },

  /**
   * 预约再借一笔结果页
   */
  {
    path: '/loan/again-reservation/result',
    meta: {
      title: '预约结果',
      background: '#FFF',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/loan/again-reservation/result.vue'),
  },

  {
    path: '/loan/security-auth',
    meta: {
      title: '安全认证',
      background: '#FFF',
    },
    component: () => import('@/views/loan/security-auth.vue'),
  },
  /**
   * 超时
   */
  {
    path: '/loan/waiting/timeout',
    meta: {
      title: '评级超时',
      background: '#FFF',
      excludeTracking: true,
      customNavBar: true,
    },
    component: () => import('@/views/loan/waiting-timeout.vue'),
  },
  /**
   * 放款结果
   */
  {
    path: '/loan/mandatory-rejected-result',
    meta: {
      title: '放款结果',
      excludeTracking: true,
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/loan/mandatory-rejected-result.vue'),
  },
] as RouteConfig[];
